import { Link } from 'react-router-dom';
import { tradingSummary } from '@/utils/tradingSummary';

const scopeRows = [
  { label: 'MARKET', value: 'XAUUSD' },
  { label: 'INSTRUMENTS', value: '1' },
  { label: 'DIRECTIONS', value: 'LONG · SHORT' },
  { label: 'PLATFORM', value: 'MetaTrader 5' },
  { label: 'DECISION BASIS', value: 'Predefined Conditions' },
  { label: 'RECORDED TRADES', value: String(tradingSummary.totalTrades) },
];

function Hero() {
  return (
    <section id="top" className="relative pt-[76px] overflow-hidden">
      <div className="absolute -top-24 right-[-6%] w-[520px] h-[520px] rounded-full bg-accent-200/40 blur-3xl pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[48fr_52fr] gap-12 lg:gap-16 items-center">
          <div className="w-full">
            <div className="inline-flex items-center gap-2 px-3 h-8 rounded-full border border-primary-300 bg-primary-50 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-[11px] font-data tracking-[0.18em] text-primary-700">
                GOLD STRATEGY · XAUUSD · MT5
              </span>
            </div>

            <h1 className="font-heading font-extrabold text-foreground-950 tracking-tight text-[36px] leading-[1.06] sm:text-[48px] lg:text-[58px]">
              One Instrument.
              <br />
              One Framework.
            </h1>

            <p className="mt-6 font-heading font-semibold text-foreground-700 text-lg md:text-xl max-w-[560px]">
              The strategy is built around a single market and a predefined set of trading
              conditions.
            </p>

            <p className="mt-4 text-[15px] md:text-base leading-relaxed text-foreground-600 max-w-[540px]">
              Rather than reacting to every price movement, the system evaluates XAUUSD against its
              own conditions and only proceeds when those conditions are met.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link
                to="/how-it-works"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
              >
                See How It Works
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/trade-journal"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-300 text-foreground-950 text-[15px] font-semibold whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
              >
                View Trade Journal
              </Link>
            </div>

            <p className="mt-7 text-[12px] font-data tracking-[0.16em] text-foreground-400">
              SPECIALIZED · RULE-BASED · RECORDED
            </p>
          </div>

          <div className="w-full">
            <div className="mb-3 flex items-center justify-between">
              <span className="text-[11px] font-data tracking-[0.2em] text-foreground-500">
                STRATEGY SCOPE
              </span>
              <span className="text-[11px] font-data tracking-[0.2em] text-foreground-400">
                {tradingSummary.latestYear}
              </span>
            </div>

            <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
              <div className="flex items-center justify-between px-4 md:px-5 h-12 border-b border-background-200 bg-background-100">
                <span className="text-[12px] font-data tracking-widest text-foreground-700">
                  SYSTEM SPECIFICATION
                </span>
                <span className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
                  <span className="text-[10px] font-data tracking-widest text-primary-600">
                    DEFINED
                  </span>
                </span>
              </div>

              <div className="px-4 md:px-5 py-2">
                {scopeRows.map((row) => (
                  <div
                    key={row.label}
                    className="flex items-center justify-between gap-4 py-3.5 border-b border-background-200 last:border-b-0"
                  >
                    <span className="text-[11px] font-data tracking-[0.14em] text-foreground-500">
                      {row.label}
                    </span>
                    <span className="text-[13px] font-data text-foreground-950 whitespace-nowrap">
                      {row.value}
                    </span>
                  </div>
                ))}
              </div>

              <div className="px-4 md:px-5 py-3.5 border-t border-background-200 bg-background-100 flex items-center justify-between">
                <span className="text-[11px] font-data tracking-[0.14em] text-foreground-500">
                  RECORDED PERIOD
                </span>
                <span className="text-[12px] font-data text-primary-700 whitespace-nowrap">
                  {tradingSummary.period}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;